package dk.smark.demo.location

import kotlin.coroutines.suspendCoroutine
import kotlinx.browser.window
import kotlin.coroutines.resume

class JsShareService : ShareService {

    override fun isSupported(): Boolean =
        js("typeof navigator.share === 'function'") as Boolean

    override suspend fun shareLocation(location: GenericLocation) {
        val url = buildLocationUrl(location)

        suspendCoroutine { continuation ->
            val shareData = js("{}")
            shareData["title"] = "My Location"
            shareData["text"] = "Here is my current location"
            shareData["url"] = url

            window.navigator.asDynamic().share(shareData)
                .then({ continuation.resume(Unit) })
                .catch({ continuation.resume(Unit) }) // User cancelled — not an error
        }
    }

    private fun buildLocationUrl(location: GenericLocation): String {
        // Links directly to your app with coords as query params
        // val base = window.location.origin
        val googleMapsUrl = "https://www.google.com/maps/search/?api=1&query=${location.latitude},${location.longitude}"
        return googleMapsUrl
    }
}

actual fun createShareService(): ShareService = JsShareService()